import {
	BlockReleaseApiResponse,
	RecommendedReleaseRejectionRequest,
	RecommendedReleaseRejectionResponse
} from '@data/blockReleases/types/BlockRelease.types';
import { rejectRecommendedRelease } from '@data/blockReleases/actionCreators/BlockReleaseActionCreators';
import { useDispatch } from 'react-redux';
import React from 'react';
import { AxiosResponse } from 'axios';
import { useGetBlockReleasesByNpi } from '@data/blockReleases/hooks/useGetBlockReleasesByNpi';
import { BlockReleaseState } from '@data/blockReleases/types/BlockReleaseState';
import { useHistory } from 'react-router-dom';
import { ROUTE_CONSTANTS } from '@utilities/RouteConstants';
import {
	useBlockReleaseRequestContext
} from '@components/BlockRelease/BlockReleaseRequest/BlockReleaseRequestContext/BlockReleaseRequestContext';
import { useSurgeons } from '@utilities/hooks/useSurgeons/useSurgeons';
import { ToastType } from '@interfaces/ToastStatus/ToastStatusState';
import { ToastConstants } from '@utilities/toastConstants';
import { useToast } from '@utilities/hooks/useToast/useToast';
import { ApiActionPayload } from '@interfaces/ApiAction/ApiActionPayload';

export const useCreateRecommendedReleaseRejectionEvent = () => {
	const dispatch = useDispatch();
	const history = useHistory();
	const displayToast = useToast();
	const { setCombinedReleases, selectedSurgeonFilter } = useBlockReleaseRequestContext();
	const { npis } = useSurgeons();
	const { getReleases } = useGetBlockReleasesByNpi();

	const handleGetReleasesSuccess = React.useCallback(
		(selectedSurgeonQueryParam: string) =>
			(res: AxiosResponse<BlockReleaseApiResponse[]>) => {
				setCombinedReleases(res.data);
				displayToast(ToastType.SUCCESS, ToastConstants.BLOCK_KEPT);
				history.replace(
					`${ROUTE_CONSTANTS.BLOCK_RELEASE_RECOMMENDATION_LIST}?${selectedSurgeonQueryParam}`,
				);
			},
		[displayToast, history, setCombinedReleases],
	);

	const handleRejectRecommendedReleaseSuccess = React.useCallback(
		() => {

			const selectedSurgeonQueryParam = new URLSearchParams({
				surgeon: selectedSurgeonFilter,
			}).toString();
			getReleases(
				{
					query: 'RELEASE_BY_NPI',
					npis,
					types: [
						BlockReleaseState.RECOMMENDED_RELEASE,
						BlockReleaseState.PENDING_RELEASE,
					],
				},
				{
					onSuccess: handleGetReleasesSuccess(selectedSurgeonQueryParam),
				},
			);
		},
		[getReleases, npis, selectedSurgeonFilter, handleGetReleasesSuccess],
	);

	const createRecommendedReleaseRejectionEvent = React.useCallback(
		(slotId: string, payload: RecommendedReleaseRejectionRequest, requestOverrides?: Partial<ApiActionPayload<RecommendedReleaseRejectionResponse>>) => {
			dispatch(
				rejectRecommendedRelease(payload, slotId, {
					onSuccess: handleRejectRecommendedReleaseSuccess,
					...requestOverrides,
				}),
			);
		},
		[dispatch, handleRejectRecommendedReleaseSuccess],
	);

	return {
		createRecommendedReleaseRejectionEvent,
	};
};
